import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

export class CustomEventComposition extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'composition-parts': `json`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
    };
  }
}

export const CustomEventCompositionEl = defineAndMakeJsxFactory(`mp-custom-event-composition`, CustomEventComposition);
